module.exports = __webpack_public_path__ + "img/logo_f.706e86e9.png";